export enum TaskManagerView {
  List = 1,
  Kanban = 2,
  Calendar = 3,
}
